import { takeEvery, takeLatest,fork, put, all, call } from "redux-saga/effects";
import axios from 'axios';
import {
  GETTOP_ARTIST,
  NEWSLETTER,
  REGISTER_ARTIST,
  USER_SUBSCRIBE,
  SET_COUNTRIES, FETCH_COUNTRIES
} from "./actionTypes";
import {
  registerUserSuccessful,
  registerUserFailed,
  userSubscribeFail,
  userSubscribeSuccessful,
  getTopArtistFail,
  getmyTopArtistSuccess,
  newsletterFail,
  newsletterSuccessful,
} from "./actions";
import {
  postRegister,
  postSubscribe,
  postTopArtist,
  postNewletter,
} from "helpers/backend_helper";

function* registerUser({ payload: { user, navigate } }) {
  try {
    const response = yield call(postRegister, user);
    navigate && navigate(response);
    if (response.status === "failure") {
      return yield put(registerUserFailed(response.message));
    }
    yield put(registerUserSuccessful(response));
    navigate.push("/");
  } catch (error) {
    yield put(registerUserFailed(error));
  }


  // try {
  //   if (!user.policy) {
  //     window.scrollTo(0, 0);
  //     return yield put(registerUserFailed("Please agree terms and condition!"));
  //   }
  //   const response = yield call(postRegister, user);
  //   if (response.status == "failure") {
  //     window.scrollTo(0, 0);
  //     return yield put(registerUserFailed(response.message));
  //   }
  //   navigate && navigate("/");
  //   yield put(registerUserSuccessful(response));
  // } catch (error) {
  //   yield put(registerUserFailed("Internal Server Error"));
  // }
}

function* fetchCountriesSaga() {
  try {
    const response = yield call(axios.get, 'https://restcountries.com/v3.1/all');
    yield put({ type: SET_COUNTRIES, payload: response.data });
  } catch (error) {
  }
}

function* userSubsCribe({ payload: { user, navigate } }) {
  try {
    const response = yield call(postSubscribe, user);
    if (response.status == "failure") {
      return yield put(userSubscribeFail(response.message));
    }
    navigate && navigate(response);
    yield put(userSubscribeSuccessful(response));
  } catch (error) {
    yield put(userSubscribeFail("Internal Server Error"));
  }
}

function* onPostNewsLetter({ payload: { user, callback } }) {
  try {
    const response = yield call(postNewletter, user);
    if (response.status == "failure") {
      return yield put(newsletterFail(response.message));
    }
    callback && callback(response);
    yield put(newsletterSuccessful(response));
  } catch (error) {
    yield put(newsletterFail("Internal Server Error"));
  }
}

function* onGetTopArtist({ payload: { data, callback } }) {
  try {
    const response = yield call(postTopArtist, data);
    if (response.status === "failure") {
      return yield put(getTopArtistFail(response.message));
    }
    callback && callback(response);
    yield put(getmyTopArtistSuccess(response));
  } catch (error) {
    yield put(getTopArtistFail(""));
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_ARTIST, registerUser);
 yield takeLatest(FETCH_COUNTRIES, fetchCountriesSaga);
  yield takeEvery(USER_SUBSCRIBE, userSubsCribe);
  yield takeEvery(NEWSLETTER, onPostNewsLetter);
  yield takeEvery(GETTOP_ARTIST, onGetTopArtist);
}

function* accountSaga() {
  yield all([fork(watchUserRegister)]);
}

export default accountSaga;
